import { React, useEffect, useState } from "react";
import { listAssignedHospitalRooms } from "../../services/Api";
import cogoToast from "cogo-toast";
import { SUCCESS_RESULT } from "../../Constants";
import { Spinner } from "reactstrap";
import { useHistory, Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { getTemplate, saveVisit, listHospitalRooms } from "../../services/Api";
import { json } from "survey-creator-core";
const ConsultationRooms = (props) => {
  const history = useHistory();
  const _hospital = props.location.state || {};
  const [isLoading, setIsLoading] = useState(false);
  const [rooms, setRooms] = useState([]);
  const getRooms = () => {
    setIsLoading(false);
    try {
      if (_hospital.rooms[0]) {
        setRooms(_hospital.rooms);
      }
    } catch (e) {}

    return;
    listHospitalRooms({ hospital_id: _hospital.hospital_id })
      .then((res) => {
        setIsLoading(false);

        if (res.status == 200) {
          var response = res.data;

          if (response.status == SUCCESS_RESULT) {
            setRooms(response.data);
            localStorage.setItem("rooms", JSON.stringify(response.data));
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };

  useEffect(() => {
    getRooms();

    return () => {};
  }, []);

  const OpenRoom = (room) => {
    if (room.serial_no == 1) {
      // go to regsitartion page

      history.push({
        pathname: "/hmis/patient-registration",
        state: {
          room: room,
        },
      });
    } else {
      // go to patient list page for this room
      history.push({
        pathname: "/hmis/patient-list-for-room",
        state: {
          room: room,
        },
      });
    }
  };
  return (
    <div>
      <h1>Consultation Rooms</h1>

      <Breadcrumb className="ms-1">
        <BreadcrumbItem>
          <Link to="/hmis/dashboard"> HMIS </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link to="/hmis/dashboard"> Hospitals </Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>
          <span> {_hospital?.hospital_name}</span>
        </BreadcrumbItem>
      </Breadcrumb>
      <hr />
      <div className="d-flex justify-content-center my-1">
        {isLoading && <Spinner />}
      </div>
      <div className="row">
        <center>
          <h1>{rooms.length == 0 && "No rooms Available"}</h1>
        </center>

 
        {rooms?.map((room, i) => {
          console.log(room);
          return (
            <div
              className="col-md-6 col-xl-4"
              key={i}
              onClick={() => OpenRoom(room)}
            >
              <div
                className="card text-white bg-secondary m-10"
                style={{ margin: "10px" }}
              >
                <div className="card-body">
                  <p className="card-text text-center h2 text-white">
                    {room.room_name}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ConsultationRooms;
